import { ProductCategory } from '../types/product';
import { images } from './images';

export const proofPoints = [
  '25+ years in packaging',
  'Manufactured in Umm Al Quwain',
  'Supplying UAE, Oman and Saudi Arabia',
  'Custom sizes to your specification',
];

export const madeHere = [
  {
    slug: 'paper-core',
    name: 'Paper Cores',
    linkLabel: 'Paper Core',
    description:
      'Custom cores for film, paper, board and converting rolls. Tell us the inner diameter, wall thickness, length and quantity, and we size the core to your winding equipment.',
    variants: 'Custom sizes',
    sendUs: 'Inner diameter, wall thickness, length, quantity, application',
    image: images.paperCores,
    alt: 'Paper cores stacked end-on at Universal Packaging Industries, Umm Al Quwain',
  },
  {
    slug: 'stretch-films',
    name: 'Stretch Film',
    linkLabel: 'Stretch Films',
    description:
      'Hand grade, machine grade, power grade and mini rolls for pallet wrapping and load securing.',
    variants: 'Hand, machine, power grade (200 to 400% prestretch), mini rolls',
    sendUs: 'Grade, width, thickness, roll length, core size, quantity',
    image: images.stretchFilm,
    alt: 'Stretch film rolls ready for dispatch at Universal Packaging Industries, Umm Al Quwain',
  },
];

export const supplyGroups: { name: string; items: string[]; category: ProductCategory; image: string }[] = [
  { name: 'Paper', items: ['Fluting paper'], category: 'Paper', image: images.flutingPaper },
  {
    name: 'Shrink films',
    items: ['POF shrink film', 'LDPE shrink film'],
    category: 'Films',
    image: images.shrinkFilm,
  },
  {
    name: 'Flexible packaging',
    items: ['Laminates', 'BOPP film', 'Thermoforming film', 'Vacuum bags', 'PA/PE casings'],
    category: 'Films',
    image: images.flexiblePacks,
  },
  {
    name: 'Labels and sleeves',
    items: ['OPP labels', 'PVC sleeves'],
    category: 'Labels and Sleeves',
    image: images.labelsSleeves,
  },
  {
    name: 'End of line',
    items: ['Strap and buckles', 'Caution tape', 'LDPE tissue rolls and pouches'],
    category: 'End of Line',
    image: images.strapping,
  },
  {
    name: 'Machines',
    items: ['Shrink wrap and sleeve wrapping machines'],
    category: 'Machines',
    image: images.shrinkMachine,
  },
];

export const mission =
  "To understand each customer's application and supply the right packaging material, with clear specifications and steady support from enquiry to delivery.";

export const vision =
  'To build lasting relationships with businesses across the GCC by growing our manufacturing capability and widening the range of materials we can supply.';

export const orderSteps = [
  { title: 'Send your spec', text: 'Product, size, grade and quantity, or an existing spec sheet.' },
  { title: 'We review it', text: 'We review it and confirm the right material.' },
  { title: 'Get a quotation', text: 'You get a quotation with lead time.' },
  { title: 'Produce and deliver', text: 'We produce or source, then deliver.' },
];
